import React, { useState } from 'react';
import { Button, Grid, TextField } from '@material-ui/core';

const CaptureWithComment = ({
  tag,
  inputCommentName,
  handleCommentInputChange,
  saveFlagWithComment,
  onClose
}) => {
  const handleButtonSave = () => {
    saveFlagWithComment(tag, inputCommentName);
    onClose();
  };

  return (
    <div>
      <Grid item className="capture-flags-modal__create-textfield-container">
        <TextField
          className="capture-flags-modal__create-input-textfield"
          placeholder="Add a comment"
          inputProps={{ 'aria-label': 'create comment input' }}
          value={inputCommentName}
          onChange={handleCommentInputChange}
          multiline
          minRows={1}
          maxRows={3}
        />
      </Grid>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        style={{ marginTop: '20px' }}
      >
        <Grid item xs={12}>
          <Button
            className="capture-flags-modal-save-btn"
            style={{ justifyContent: 'center' }}
            onClick={handleButtonSave}
          >
            <span className="btn__title">Save</span>
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default CaptureWithComment;
